import "styles/Contact.css";

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Section from "components/Section";
import Button from "components/Buttons";
import Avartar from "components/Avartar";
import Row from "components/Row";
import { Text } from "components/Texts";
import contactAction from "../modules/contact/actions";
import contactSelectors from "../modules/contact/selectors";
import mainSelectors from "../modules/main/selectors";
import { useTranslation } from "react-i18next";
import { compose } from "redux";
import withUserPerm from "services/withUserPerm";

const Contact = () => {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const rmpToken = sessionStorage.getItem("rmp_token");
  const currentAd = useSelector((state) => mainSelectors.currentAd(state));
  console.log("contact currentAd id=>", currentAd);
  useEffect(() => {
    dispatch(contactAction.GetContactInfo(rmpToken, currentAd.ads_account_id));
  }, [currentAd.ads_account_id, dispatch, rmpToken]);
  const getContactInfoResult = useSelector((state) => contactSelectors.getContactInfoResult(state));
  const specialistInfo = getContactInfoResult.data;
  return (
    <Section>
      <Row className="contact-img-container">
        <Avartar src={specialistInfo.image} align="center"></Avartar>
      </Row>
      <Text align="center">{(specialistInfo.name_en || "") + " " + (specialistInfo.lastname_en || "")}</Text>
      <Text align="center">{(specialistInfo.name_th || "") + " " + (specialistInfo.lastname_th || "")}</Text>
      <Text align="center">
        {t("__contact_email")} {specialistInfo.email || "-"}
      </Text>
      <Text align="center">
        {t("__contact_tel")} {specialistInfo.phone_direct || specialistInfo.tel || "-"}
      </Text>
      <Row className="button-container">
        <Button round onClick={() => mailToSpecialist(specialistInfo.email)}>
          {t("__contact_click_email")}
        </Button>
        <Button round onClick={() => callSpecialist(specialistInfo.phone_direct || specialistInfo.tel)}>
          {t("__contact_click_to_call")}
        </Button>
      </Row>
    </Section>
  );
};

export default compose(withUserPerm())(Contact);

const callSpecialist = (tel) => {
  window.open("tel:" + tel, "_self");
};

const mailToSpecialist = (email) => {
  window.open("mailto:" + email, "_self");
};
